import { render } from "./RegistrationRequestPanel.vue?vue&type=template&id=783d605a"
import script from "./RegistrationRequestPanel.vue?vue&type=script&lang=ts"
export * from "./RegistrationRequestPanel.vue?vue&type=script&lang=ts"
script.render = render

export default script